<div class="page-container h-100 pb-5">
  <div class="page-content h-100">

    <div class="filter-row mb-3">
      <div class="filter-item">
        <label class="gray-text">{{'planner.weeklyPlanningMap.showMapLayer' | translate}}</label>
        <select class="btn btn-secondary fs-small" [(ngModel)]="mainSelection" (change)="changeMainSelect($event.target.value, true)">
          @if (customerId !== 3) {
            <option [ngValue]="0">{{'planner.weeklyPlanningMap.frames' | translate}}</option>
          }
          @if (customerId !== 3) {
            <option [ngValue]="1">{{'planner.weeklyPlanningMap.inverters' | translate}}</option>
          }
          @if (customerId === 3) {
            <option [ngValue]="2">{{'planner.weeklyPlanningMap.powerlines' | translate}}</option>
          }
        </select>
      </div>
      <div class="filter-item">
        <label class="gray-text">{{ 'basic.selectPhase' | translate }}</label>
        <div ngbDropdown>
          <button class="btn btn-secondary fs-small" type="button" id="dropdownPhase" ngbDropdownToggle>
            @if (selectedStatus) {
              <span>{{selectedStatus.definition}}</span>
            }
            @if (!selectedStatus) {
              <span>No status</span>
            }
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownPhase">
            @for (status of statuses; track $index) {
              <div>
                @if (!status.hidden) {
                  <button
                    ngbDropdownItem
                    type="button"
                    (click)="onStatusChange(status, true)">
                    {{status.definition}}
                  </button>
                }
              </div>
            }
          </div>
        </div>
      </div>
      <div class="filter-item">
        <label class="gray-text">{{'basic.selectWorkerteam' | translate}}</label>
        <select class="btn btn-secondary fs-small" [disabled]="workerteamsLoading" [(ngModel)]="selectedWorkerteam"
          (change)="changeWorkerteamFilter($event)">
          <option value="filterOff">{{'basic.all' | translate}}</option>
          @for (group of groups; track $index) {
            <option [ngValue]="group.id">
              {{ group.name }}
            </option>
          }
        </select>
      </div>
      <div class="filter-item">
        <label class="gray-text">{{'basic.filter' | translate}}</label>
        <select class="btn btn-secondary fs-small" [(ngModel)]="selectedFilter" (change)="changeFilter()">
          <option value="filterOff">{{'basic.filterOff' | translate}}</option>
          <option value="scheduled">{{'basic.scheduled' | translate}}</option>
          <option value="notScheduled">{{'basic.notScheduled' | translate}}</option>
          <option value="done">{{'basic.done' | translate}}</option>
          <option value="interrupted">{{'basic.interrupted' | translate}}</option>
        </select>
      </div>
      <div class="filter-info">
        <img class="card-icon" src="assets/icons/info_blue_24dp.svg" (mouseover)="showColors = true" (mouseout)="showColors = false">
        @if (showColors) {
          <div class="colorbox">
            <div>
              <span class="dot" [ngStyle]="{'background-color': interruptedColor}"></span>
              {{'basic.interrupted' | translate}}
            </div>
            @for (status of statuses; track $index) {
              <div>
                <span class="dot" [ngStyle]="{'background-color': status.color}"></span>
                {{ status.definition }}
              </div>
            }
          </div>
        }
      </div>
    </div>



    <div class="map-height">
      <!--
      <div *ngIf="selectedMarkersCount > 0" class="selected-count">
        {{ selectedMarkersCount }} markers selected
        <div class="add-all-to-one-slot">
          <input type="checkbox" [(ngModel)]="addToSingleSlot" id="singleSlotCheckbox">
          <label for="singleSlotCheckbox">Add all to one slot</label>
        </div>
        <div *ngIf="selectedMarkers.length > 0" class="selected-ids">
          <span *ngFor="let marker of selectedMarkers; let last = last">
            <span *ngIf="marker.identifier">
              <span *ngIf="customerId === 2 && marker.transformer">{{ marker.transformer }}-{{ marker.inverter }}<span *ngIf="marker.circuit"> - {{marker.circuit}}</span></span>
              <span *ngIf="customerId !== 2 || !marker.transformer">{{marker.identifier}}</span>
            </span>
            <span *ngIf="!marker.identifier && marker.transformer">{{ marker.transformer }}-{{ marker.inverter }}</span>
            <ng-container *ngIf="!last">, </ng-container>
          </span>
        </div>
      </div>
      -->
      <div [hidden]="selectedMarkersCount === 0" class="selected-count">
        <div>Selected ({{selectedMarkersCount}})</div>
        <div class="d-flex justify-content-between">
          <div>Installation time</div>
          <div class="blue-text ms-2">{{totalTime}}</div>
        </div>
        <hr>
          @if (showIds === false) {
            <div class="cursor-pointer d-flex justify-content-between" (click)="showIds = true">
              <span>Show IDs</span>
              <img src="assets/icons/expand_more_black_24dp.svg">
            </div>
          }
          @if (showIds === true) {
            <div>
              <div (click)="showIds = false" class="cursor-pointer d-flex justify-content-between">
                <span>Hide IDs</span>
                <img src="assets/icons/expand_less_black_24dp.svg">
              </div>
              <div class="container-size-markers">
                @for (marker of selectedMarkers; track $index) {
                  <div>
                    @if (marker.identifier) {
                      <span>
                        @if (customerId === 2 && marker.transformer) {
                          <span>{{ marker.transformer }}-{{ marker.inverter }}@if (marker.circuit) {
                            <span> - {{marker.circuit}}</span>
                          }</span>
                        }
                        @if (customerId !== 2 || !marker.transformer) {
                          <span>{{marker.identifier}}</span>
                        }
                      </span>
                    }
                    @if (!marker.identifier && marker.transformer) {
                      <span>{{ marker.transformer }}-{{ marker.inverter }}</span>
                    }
                  </div>
                }
              </div>
            </div>
          }
          <hr>
            <div class="add-all-to-one-slot">
              <input type="checkbox" [(ngModel)]="addToSingleSlot" id="singleSlotCheckbox">
              <label for="singleSlotCheckbox">Add all to one slot</label>
            </div>
          </div>

          <div id="mapmap" class="map-container structure-child"></div>
        </div>

        <div class="bottom-container">
          @if (tableSpinner) {
            <div class="row week-picker d-flex justify-content-center align-items-center">
              <div class="col-4 mt-1">
                <div class="d-flex justify-content-center mt-2">
                  <img class="chevron p-2" src="assets/icons/chevron_left_gray_24dp.svg" (click)="lastWeek()">
                  <div class="text-center px-3">
                    <span class="gray-text">{{'basic.week' | translate }} {{weekNr}}</span>
                    <br>
                      @if (globalStartDate) {
                        <span>{{ globalStartDate?.getDate() }}.{{
                          globalStartDate?.getMonth() + 1}}.{{ globalStartDate?.getFullYear() }} - {{
                          globalLastDate?.getDate() }}.{{ globalLastDate?.getMonth() + 1}}.{{
                        globalLastDate?.getFullYear() }}</span>
                      }
                    </div>
                    <img class="chevron p-2" src="assets/icons/chevron_right_gray_24dp.svg" (click)="nextWeek()">
                  </div>
                </div>
              </div>
            }
            <!-- <load-spinner *ngIf="tableSpinner" class="spinner-table"></load-spinner> -->

            <div class="calendar-container">
              @for (calendar of calendarsDataArray; track $index) {
                <div class="calendar">
                  <div style="display: flex; align-items: center;">
                    <h3 style="font-size: 20px; margin-right: 15px;">{{getTeamNameOfCalendar(calendar.calendarData) || calendar.calendarData.name}} {{'planner.weeklyPlanningMap.calendar' | translate}}</h3>
                    <img src="/assets/icons/groups_black_24dp.svg" alt="Group Icon"
                      style="margin-right: 15px; transform: translateY(-5px);">
                    <!-- Added translateY transform -->
                    <span style="transform: translateY(-5px);">{{
                    getWorkerCountForSelectedCalendar(calendar.calendarData.id) }}</span>
                    <!-- Added translateY transform -->
                  </div>
                  <table class="table table-bordered text-center">
                    <tr>
                      <!-- <th scope="col"></th> -->
                      @for (day of calendarDays; track $index; let i = $index) {
                        <th scope="col">
                          {{ getDayName(day) }} {{ getDatePart(day) }}.{{ getMonthPart(day) }}
                        </th>
                      }
                    </tr>
                    @if (loading) {
                      <tbody><load-spinner></load-spinner></tbody>
                    }
                    @if (!loading) {
                      <tbody>
                        @for (slot of calendar.slotRows; track $index; let index = $index) {
                          <td class="relative"
                            [style.z-index]="100" [ngClass]="{'slot-disabled': slot.disabled}">
                            <div class="slot-container"
                              [style.background]="slot.color"
                              [style.cursor]="selectSlotMode ? 'pointer' : null"
                              (click)="selectSlot(slot.id, slot.date, calendar.calendarData.id)">
                              <div class="mt-1 w-100 d-flex justify-content-center">
                                <div class="left">
                                  @if (!slot.workorders) {
                                    <span>{{calendar.calendarData.workdayLength.hours}}h {{calendar.calendarData.workdayLength.minutes}}m</span>
                                  }
                                  @if (slot.workorders) {
                                    <span>{{slot.starttime | date: 'HH:mm'}} - {{slot.endtime | date: 'HH:mm'}}</span>
                                  }
                                </div>
                                <img src="/assets/icons/Bin.svg" alt="Delete Icon"
                                  (click)="emptySlot(slot.id, calendar.calendarData.id)">
                              </div>
                              <div class="d-table h-100 w-100" style="min-height: 30px;">
                                <div class="slot-stuff">
                                  @if (!slot.disabled && !bypassMode && selectSlotMode) {
                                    <div class="d-flex align-items-center justify-content-center"
                                      >
                                      <img height="30px" src="/assets/icons/add_gray_24dp.svg">
                                      @if (slot.startHere === true) {
                                        <span
                                          class="start-here">{{'planner.weeklyPlanningMap.startHere' |
                                        translate}}</span>
                                      }
                                    </div>
                                  }
                                  <div class="slot-details">
                                    <!-- Container for the first 9 work orders -->
                                    <div class="slot-items" [ngClass]="(customerId === 2 || customerId === 4 || customerId === 3) ? 'slot-items-grid-template-1 d-flex align-items-center flex-column' : 'slot-items-grid-template-3'">
                                      @for (workOrder of limitedWorkorders(slot.workorders); track $index) {
                                        <div
                                          class="workorder-block" [style.background]="selectedStatus.color"
                                          title="{{workOrder.identifier}}"
                                          [ngClass]="(customerId === 2 || customerId === 3 || customerId === 4) ? 'w-1' : 'w-3'">
                                          @if (customerId !== 2 && customerId !== 4 && customerId !== 3) {
                                            <span>{{workOrder.id}}</span>
                                          }
                                          @if (customerId === 2 && workOrder.transformer) {
                                            <span>{{workOrder.transformer}} - {{workOrder.inverter}}@if (workOrder.circuit) {
                                              <span> - {{workOrder.circuit}}</span>
                                            }</span>
                                          }
                                          @if (customerId === 2 && !workOrder.transformer) {
                                            <span>{{workOrder.identifier}}</span>
                                          }
                                          @if (customerId === 3) {
                                            <span>{{workOrder.identifier}}</span>
                                          }
                                          @if (customerId === 4) {
                                            <span>{{workOrder.identifier}}</span>
                                          }
                                        </div>
                                      }
                                    </div>
                                    <!-- Custom expand arrow -->
                                    @if (slot.workorders && slot.workorders.length > 9 && customerId !== 2 && customerId !== 4 && customerId !== 3) {
                                      <div
                                        class="expand-arrow" (click)="toggleExpand(slot.id)">
                                        {{ expandedSlotId === slot.id ? '&#x25B2;' : '&#x25BC;' }}
                                      </div>
                                    }
                                    @if (slot.workorders && slot.workorders.length > 3 && (customerId === 2 || customerId === 4 || customerId === 3)) {
                                      <div
                                        class="expand-arrow" (click)="toggleExpand(slot.id)">
                                        {{ expandedSlotId === slot.id ? '&#x25B2;' : '&#x25BC;' }}
                                      </div>
                                    }
                                    <!-- Remaining work orders, shown only if expanded -->
                                    @if (expandedSlotId === slot.id) {
                                      <div class="slot-items" [ngClass]="(customerId === 2 || customerId === 3 || customerId === 4) ? 'slot-items-grid-template-1 d-flex align-items-center flex-column' : 'slot-items-grid-template-3'">
                                        @for (workOrder of remainingWorkorders(slot.workorders); track $index) {
                                          <div
                                            class="workorder-block" [style.background]="selectedStatus.color"
                                            title="{{workOrder.identifier}}"
                                            [ngClass]="(customerId === 2 || customerId === 3 || customerId === 4) ? 'w-1' : 'w-3'">
                                            @if (customerId !== 2 && customerId !== 3 && customerId !== 4) {
                                              <span>{{workOrder.id}}</span>
                                            }
                                            @if (customerId === 2) {
                                              <span>{{workOrder.transformer}} - {{workOrder.inverter}} @if (workOrder.circuit) {
                                                <span> - {{workOrder.circuit}}</span>
                                              }</span>
                                            }
                                            @if (customerId === 3) {
                                              <span>{{workOrder.identifier}}</span>
                                            }
                                            @if (customerId === 4) {
                                              <span>{{workOrder.identifier}}</span>
                                            }
                                          </div>
                                        }
                                      </div>
                                    }
                                  </div>
                                </div>
                              </div>
                              @if (!slot.disabled && !bypassMode && getTime(slot.starttime, slot.endtime)) {
                                <div
                                  class="progress-bars">
                                  @if (slot.notFree || slot.freeAccess) {
                                    <div>
                                      <div class="dual-container mt-1">
                                        <div class="ml-1 left d-flex">
                                          <img src="/assets/icons/calendar_available_black_24dp.svg">
                                          @if (slot.notFree) {
                                            <span class="small">{{slot.notFree}}%</span>
                                          }
                                          @if (!slot.notFree) {
                                            <span class="small">0%</span>
                                          }
                                        </div>
                                        <div class="progress progress-primary right">
                                          <div class="progress-bar" role="progressbar"
                                            [ngStyle]="setProgress(slot.notFree)" aria-valuenow="0"
                                            aria-valuemin="0" aria-valuemax="100">
                                          </div>
                                        </div>
                                      </div>
                                      <div class="dual-container mt-1 mb-1">
                                        <div class="ml-1 left d-flex">
                                          <img src="/assets/icons/calendar_month_black_24dp.svg">
                                          @if (slot.freeAccess) {
                                            <span
                                            class="small">{{slot.freeAccess}}%</span>
                                          }
                                          @if (!slot.freeAccess) {
                                            <span class="small">0%</span>
                                          }
                                        </div>
                                        <div class="progress progress-primary right">
                                          <div class="progress-bar" role="progressbar"
                                            [ngStyle]="{ 'width': calculateFillPercentage(slot, calendar.originalCalendarData.slot_max_default) }"
                                            aria-valuenow="calculateFillPercentage(slot)" aria-valuemin="0"
                                            aria-valuemax="100">
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  }
                                  @if (!slot.notFree && !slot.freeAccess) {
                                    <div class="progress-bars-empty">
                                      <div class="align-center justify-content-center gray-text">
                                        <div class="dual-container justify-content-center mt-1 mb-1">
                                          @if (slot.workorders && slot.workorders.length > 0) {
                                            <span class="pill pill-3"
                                              [ngClass]="slot.slot_max != null ? 'slot_max_pill' : 'default_pill'"
                                              [ngStyle]="{'background-color': slot.slot_max != null ? selectedStatus.color : ''}">
                                              {{ slot.fill }}/{{ slot.duration / 100 * (slot.slot_max !=
                                              null ? slot.slot_max :
                                              calendar.originalCalendarData.slot_max_default) }} min
                                            </span>
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          </td>
                        }
                      </tbody>
                    }
                  </table>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
